import { endOfYesterday, format, getHours } from 'date-fns';
import React, { memo } from 'react';

import { Link } from '@sravni/react-design-system/lib/Typography';
import type IProduct from '@sravni/vitrina/lib/types/IProduct';

import productTypes from '@components/RatingTable/components/ProductPopup/enums/productTypes';

import { useProductConfig } from '../../../../../../../store/hooks/productPopupInfo';
import DownloadIcon from '../Icons/DownloadIcon';
import SecurityShield from '../Icons/SecurityShield';

import style from './style.module.scss';

interface IProps {
  product: IProduct;
}

const date = format(Date.now(), 'dd.MM.yyyy');
const time = getHours(Date.now());

const midday = Number(time) < 12 ? format(endOfYesterday(), 'dd.MM.yyyy') : date;

const DepositConditionBlock: React.FC<IProps> = memo(({ product }) => {
  const link = product.depositConditionLink;
  const text = `Полные условия по вкладу на ${midday}`;
  const productConfig = useProductConfig();
  const isDeposits = productConfig.name === productTypes.Deposits;

  if (!isDeposits || !link) {
    return null;
  }

  return (
    <div className={style.wrapper}>
      <div className={style.info}>
        <div className={style.picture}>
          <SecurityShield />
        </div>
        <div className={style.infoText}>Все вклады застрахованы</div>
      </div>
      <Link href={link} className={style.terms} target="_blank">
        <div className={style.picture}>
          <DownloadIcon />
        </div>
        <div className={style.termText}>{text}</div>
      </Link>
    </div>
  );
});

export default DepositConditionBlock;
